import { render, staticRenderFns } from "./SoftWareDetail.vue?vue&type=template&id=1621a688&scoped=true"
import script from "./SoftWareDetail.vue?vue&type=script&lang=js"
export * from "./SoftWareDetail.vue?vue&type=script&lang=js"
import style0 from "./SoftWareDetail.vue?vue&type=style&index=0&id=1621a688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621a688",
  null
  
)

export default component.exports